import { Product, SortDirection } from 'types';
import { buildEmptyProduct } from 'components/ProductDetails';

export const sortByProducts = (
  taxonProducts: Product[],
  sortType: SortDirection | string
) => {
  let sortedData;

  switch (sortType) {
    case SortDirection.PriceAsc:
      sortedData = [...taxonProducts].sort((p1, p2) => p1.price - p2.price);
      break;
    case SortDirection.PriceDesc:
      sortedData = [...taxonProducts].sort((p1, p2) => p2.price - p1.price);
      break;
    case SortDirection.AlphaAsc:
      sortedData = [...taxonProducts].sort((p1, p2) =>
        p1.name.localeCompare(p2.name)
      );
      break;
    case SortDirection.AlphaDesc:
      sortedData = [...taxonProducts].sort((p1, p2) =>
        p2.name.localeCompare(p1.name)
      );
      break;
      case SortDirection.OldestFirst:
      sortedData = [...taxonProducts].sort(
        (p1, p2) =>
          new Date(p1.AvailableOn).getTime() -
          new Date(p2.AvailableOn).getTime()
      );
      break;
    case SortDirection.NewestFirst:
      sortedData = [...taxonProducts].sort(
        (p1, p2) =>
          new Date(p2.AvailableOn).getTime() -
          new Date(p1.AvailableOn).getTime()
      );
      break;
    default:
      sortedData = taxonProducts;
  }
  return sortedData;
};

export const buildEmptyProductsForCategoryPreview = () => {
  return [
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
  ];
};
